export default __webpack_public_path__ + "static/media/create-endo-preference-icon.cde8b32f.svg";